export class HttpClient {

    async get( url ) {

        const resp = await fetch( url );
        const data = await resp.json();

        return { data, status: resp.status };
    }

    async post( url ) {

        const resp = await fetch( url, {
            method: "POST"
        });
        const data = await resp.json();

        return { data, status: resp.status };
    }

    async postBody( url, bodyData = {}) {
        try {
            const resp = await fetch(
                url,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: bodyData
                }
            );
            
            const data = await resp?.json();
            console.log("postBody response", data, resp.status)
            if(resp.status!==200){
                return { data : false, status:'error'}
            }
            return { data, status: resp.status };  
        }catch (error){
            
            console.error("Error postBody:", error);
            return { data : false, status:'error'}
        }
    }

    async getHTML( url ) {

        try {
            const resp = await fetch( 
                url,
                {
                    method: "GET",
                    headers: {"Content-Type": "text/html", 'Accept': "text/html;","Access-Control-Allow-Origin": "*"}
                }
            );
            
            let bodyHtml = await resp.text()
            bodyHtml = bodyHtml.split("<body")[1].split(">").slice(1).join(">").split("</body>")[0];
            
            return { bodyHtml, status: resp.status };

        }catch (error) {
            console.log('Ocurrio un error al intentar obteners condiciones:', error);
            return { bodyHtml:"", status: 405 };
        }
    }
}